module.exports = __webpack_public_path__ + "static/media/step-two-small.a10c80ab.jpg";